import { statusLabel } from "./tenantRequestFields";

/**
 * The shared status tones, one per stage a request can be at. Anything the
 * API adds later reads as neutral rather than as nothing.
 */
const TONES = {
  Open: "submitted",
  In_Progress: "warning",
  Onboarded: "published",
  Closed: "archived",
};

export function TenantRequestStatusBadge({ status }) {
  if (!status) {
    return <span className="text-[12px] per-file-hint">—</span>;
  }

  const tone = TONES[status] ?? "archived";
  return (
    <span
      className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-semibold"
      style={{
        backgroundColor: `var(--status-${tone}-bg)`,
        color: `var(--status-${tone}-fg)`,
      }}
    >
      <span
        className="h-1.5 w-1.5 rounded-full"
        style={{ backgroundColor: `var(--status-${tone}-dot)` }}
      />
      {statusLabel(status)}
    </span>
  );
}

export default TenantRequestStatusBadge;
